function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M78.274,69.651h-8.893V8.099c0-1.227-.999-2.226-2.226-2.226h-18.095c-1.228,0-2.226.999-2.226,2.226v15.106h-15.894c-1.227,0-2.226.999-2.226,2.226v12.345h-15.87c-1.228,0-2.226.999-2.226,2.226v29.65H1.726c-1.227,0-2.226.999-2.226,2.226s.999,2.226,2.225,2.226l11.014.013.052.011h36.256l.186-.024h29.041c1.228,0,2.226-.999,2.226-2.226s-.999-2.226-2.226-2.226ZM64.931,10.324v59.326h-13.646V10.324h13.646ZM28.714,42.227v27.424h-13.645v-27.424h13.645ZM46.834,27.656v41.994h-13.668V27.656h13.668Z"
});

var SvgNavGraph = function SvgNavGraph(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavGraph, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_graph.460509f9.svg";
export { ForwardRef as ReactComponent };